import { motion } from 'framer-motion';
import {
  Smartphone,
  CreditCard,
  Settings,
  BarChart3,
  Users,
} from 'lucide-react';

const services = [
  {
    icon: Smartphone,
    title: 'Online Food Ordering',
    description:
      'User-friendly web and mobile platform where employees can browse daily menus, pre-order meals, and schedule pickups or dine-in at their convenience. No more long queues or limited lunch breaks.',
    color: 'bg-[#FFC000]',
  },
  {
    icon: CreditCard,
    title: 'Digital Payments',
    description:
      'Secure and cashless payment system supporting multiple payment methods including UPI, credit/debit cards, mobile wallets, and company-issued meal credits. Fast, safe, and fully trackable.',
    color: 'bg-[#F5A623]',
  },
  {
    icon: Settings,
    title: 'Customizable Cafeteria Management',
    description:
      'Integration with internal systems offering branded interfaces, custom meal plans, subsidized billing options, and employee dietary preferences management.',
    color: 'bg-[#0066CC]',
  },
  {
    icon: BarChart3,
    title: 'Real-Time Analytics & Reporting',
    description:
      'Backend dashboard providing detailed insights into food preferences, ordering patterns, and transaction history. Manage costs, reduce waste, and improve cafeteria offerings.',
    color: 'bg-[#F5A623]',
  },
  {
    icon: Users,
    title: 'Multi-Vendor Support',
    description:
      'Seamless coordination and vendor management under one digital ecosystem, whether your cafeteria is managed by a single caterer or multiple food partners.',
    color: 'bg-[#0066CC]',
  },
];

const Services = () => {
  return (
    <section
      id="services"
      className="section-padding bg-gray-50"
      data-testid="services-section"
    >
      <div className="container-custom">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="section-header"
        >
          <span className="text-[#0066CC] text-sm font-semibold uppercase tracking-wider mb-4 block">
            Our Services
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            An Innovative Software and IT Services
          </h2>
          <div className="accent-bar mx-auto mb-6" />
          <p className="text-base md:text-lg text-gray-600 leading-relaxed">
            We offer comprehensive Software and IT services tailored to meet the evolving
            needs of modern businesses and their cafeteria operations.
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="service-card group"
              data-testid={`service-card-${index}`}
            >
              <div
                className={`w-14 h-14 ${service.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}
              >
                <service.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 mb-6">
            Ready to transform your cafeteria operations?
          </p>
          <a
            href="#contact"
            className="btn-primary inline-flex items-center gap-2"
            data-testid="services-cta-btn"
          >
            Schedule a Demo
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
